/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import jwt_decode from "jwt-decode";
import Navbar from "../Navbar";
import Header from "../Header";
import baseUrl from "../BaseUrl";
import Loader from "../Loader";
import { useNavigate, Link } from 'react-router-dom';
import Pagination from "react-js-pagination";
 
const TagsSettings = () => {
    // --- Component State ---
    const [name, setName] = useState('');
    const [token, setToken] = useState('');
    const [expire, setExpire] = useState('');
    const [apiError, setApiError] = useState(null);
    const [role, setRole] = useState('');
    const [cid, setCid] = useState('');
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
   
    const [newTags, setNewTags] = useState({ tag_name: '', company_id: '' });
    const [isEditing, setIsEditing] = useState(false);
    const [isAdd, setIsAdd] = useState(false);
    const [tagsList, setTagsList] = useState([]);
    const [editIndex, setEditIndex] = useState(null);
    const [access, setAccess] = useState([]);
    const [popupOpen, setPopupOpen] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    const [companyList, setcompanyList] = useState([]);
    const [userManageTagsAccess, setUserManageTagsAccess] = useState(false);
    const [selectedCompanyFilter, setSelectedCompanyFilter] = useState('');
    
    const navigate = useNavigate();

    // --- Loading State Management ---
    // A single useEffect handles the loader visibility based on a counter,
    // which simplifies managing multiple async operations.
    const [loadingCount, setLoadingCount] = useState(0);
    useEffect(() => setPopupOpen(loadingCount > 0), [loadingCount]);
    const incrementLoading = () => setLoadingCount(prev => prev + 1);
    const decrementLoading = () => setLoadingCount(prev => Math.max(prev - 1, 0));

    // --- Effects ---
    useEffect(() => {
        refreshToken();
    }, []);
    useEffect(() => {
        if (token) { // Ensure token is available before fetching
            getTagsList(page, selectedCompanyFilter);
            getUserAccess(); // Moved here to ensure token is likely set
            getCustomerNameList();
        }
    }, [page, token]);
    
    // --- Authentication & Authorization ---
    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/token`);
            
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setRole(decoded.role);
            setName(decoded.name);
            setExpire(decoded.exp);
            setCid(decoded.cid);
        } catch (error) {
           
            if (error.response) {
                // setApiError("Unauthorized");
                navigate("/");  
                window.location.reload();
            }
        }
    }

    const getUserAccess = async () => {
        try {
            const response = await axiosJWT.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
           
            setAccess(response.data.results);
            if(response.data.user_manage_tags == 0){
                navigate('/number-management');
            }
            // setIsLoading(false);
            
        } catch (error) {
           console.error("Error fetching user access:", error);
        }
    }
   
    const getCustomerNameList = async () => {
        try {
          
            const response = await axios.get(`${baseUrl}/active-user-company`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
            const allArray = response.data.filter(item => item.id !== 1);
            setcompanyList(allArray);
        } catch (error) {
           console.log(error);
            
        }
    };


   
 
    // Axios instance with JWT interceptor for automatic token refresh
    // This is a robust pattern for handling token expiration seamlessly.
    const axiosJWT = axios.create();
 
    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setName(decoded.name);
            setExpire(decoded.exp);
            setRole(decoded.role); // Also update role if it changes with token refresh
            setCid(decoded.cid);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });
 
    // --- Data Fetching ---
    const handlePageChange  = (pageNumber) => {
        setPage(pageNumber);
    }

    // Fetches the paginated list of active tags from the backend.
    const getTagsList = async (pageNumber, companyFilter = '') => {
        incrementLoading();
        try {
            const response = await axiosJWT.get(`${baseUrl}/tags-settings?page=${pageNumber}&limit=${20}&company_id=${companyFilter}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            const updatedData = response.data.data.map(item => ({
                ...item,
                company_id: item.cid
              }));
              
            setTagsList(updatedData);
            setTotalItem(response.data.totalItem);
        } catch (err) {
            console.error("Error fetching Tags List:", err);
            setApiError("Failed to load Tags List.");
        } finally {
            decrementLoading();
        }
    }

    // --- CRUD Operations ---

    const handleSearchSubmit = () => {
        setPage(1);
        getTagsList(1, selectedCompanyFilter);
    };

    const clearFilter = () => {
        setSelectedCompanyFilter('');
        setPage(1);
        getTagsList(1, '');
    };

    const handleAddTag = () => {
        setNewTags({ tag_name: '', company_id: role > 2 ? cid : '' });
        setIsEditing(false);
        setIsAdd(!isAdd);
        setEditIndex(null);
        setFormErrors({});
        setApiError(null);
    };

    const handleInputChange = (e) => {
        setNewTags({ ...newTags, [e.target.name]: e.target.value });
    };

    const validate = () => {
        const errors = {};
        const tagName = newTags.tag_name.trim();

        if (!newTags.company_id) {
            errors.company_id = 'Company is required.';
        }

        // Ensure the tag name is not just whitespace
        if (!tagName) {
            errors.tag_name = 'Tag name is required.';
        } else if (!/^[A-Za-z0-9 _-]+$/.test(tagName)) {
            errors.tag_name = "Tag name can only contain letters, numbers, spaces, underscores, and hyphens.";
        }
        return errors;
      };

    // Handles both creating a new tag and updating an existing one.
    const handleSave = async () => {
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
          setFormErrors(validationErrors);
          return;
        }
        
        let payload;

        if (isEditing) {
            payload = { id: newTags.id, tag_name: newTags.tag_name.trim(), company_id: newTags.company_id };
        } else {
            payload = { tag_name: newTags.tag_name.trim(), company_id: newTags.company_id };
          }

          try {
            setButtonDisabled(true);
            incrementLoading();
            await axiosJWT.post(`${baseUrl}/tags-settings`, payload, {headers: {
                Authorization: `Bearer ${token}`
            }});
            
            // Success: Reset form, refresh list
            setIsAdd(false);
            setIsEditing(false);
            setEditIndex(null);
            setNewTags({ tag_name: '', company_id: '' });
            getTagsList(page); // Refresh current page
            setApiError(null); // Clear previous API errors
        } catch (error) {
            console.error("Error saving Tags list:", error);
            setApiError(error.response?.data?.msg || error.response?.data?.message || "Failed to save the tag. Please try again.");
        } finally {
            setButtonDisabled(false);
            decrementLoading();
        }
        setFormErrors({}); // Clear form validation errors after attempt
    };

    // Prepares the form for editing an existing tag.
    const handleEdit = (index) => {
        const tags = tagsList[index];
        setNewTags({...tags}); // Ensure all fields like id are copied
        setIsEditing(true);
        setEditIndex(index);
        setIsAdd(false);
        setFormErrors({});
        setApiError(null);
    };

    // Disables (soft-deletes) a tag after user confirmation.
    const disableTags = async (id) => {
        const shouldDelete = window.confirm("Are you sure you want to disable this tag?");
        if (shouldDelete) {
            try {
                incrementLoading();
                await axiosJWT.delete(`${baseUrl}/tags-settings/${id}`,{headers: {
                    Authorization: `Bearer ${token}`
                }});
                getTagsList(page); // Refresh list
                setApiError(null);
            } catch (error) {
                console.error("Error disabling tags:", error);
                setApiError(error.response?.data?.msg || error.response?.data?.message || "Failed to disable the tag.");
            } finally {
                decrementLoading();
            }
        }
    }

    return (
        <div className="panelbox">
           <Navbar token={token} access={access}/>
            <div className="right-panel">
            <Header name={name} />
            {popupOpen && (
                     <Loader /> 
                ) }
            <div className="content-page admin-attendance-page">
                <div className="row">
                    {apiError && <div className="col-12"><p className="error error-message" style={{color: 'red'}}>{apiError}</p></div>}
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="left-title">
                            <h1>Tag Settings</h1>
                        </div>
                    </div>
                    <div className="col-6 inventory-btn">
                        <div className="addnew-button">
                            <Link to="/number-management"><span>&larr;</span> Back</Link>
                            <a className="newrow" onClick={handleAddTag} style={{ cursor: 'pointer' }}> Add Tag</a>
                        </div>
                    </div>
                </div>
                <div className="fullrow">
                    <div className="row">
                        <div className="col-md-9 order-filter">
                            <div className="boxinput">
                            {role <= 2 && (
                                <>
                                    <select className="company-name form-control" name="company_filter" value={selectedCompanyFilter} onChange={(e) => setSelectedCompanyFilter(e.target.value)}>
                                        <option value="">All Companies</option>
                                        {companyList.map((comp) => (
                                            <option key={comp.id} value={comp.id}>
                                                {comp.cname}
                                            </option>
                                        ))}
                                    </select>
                                    <button className="search-btn" onClick={handleSearchSubmit}>Search</button>
                                    {selectedCompanyFilter && (<a className='search-btn clear-btn' onClick={clearFilter}>Clear</a>)}
                                </>
                            )}
                            </div>
                        </div>
                        
                    </div>
                    
                    <div className="row">
                        <div className="col-12">
                        { isAdd && 
                            <div className="common-white-shadow-background setting-section">
                                <div className="row">
                                    {role <= 2 && <div className="col-sm-4" >
                                        <select name="company_id" value={newTags.company_id} onChange={handleInputChange}>
                                            <option value="">Select Company</option>
                                            {companyList.map((comp) => (
                                                <option key={comp.id} value={comp.id}>
                                                    {comp.cname}
                                                </option>
                                            ))}
                                        </select>
                                        {formErrors.company_id && <div className="error error-message">{formErrors.company_id}</div>}
                                    </div>}
                                    <div className="col-sm-4" >
                                        <input
                                            type="text"
                                            name="tag_name"
                                            placeholder="Tag Name"
                                            value={newTags.tag_name}
                                            onChange={handleInputChange}
                                            className={formErrors.tag_name ? 'input-error' : ''}
                                        />
                                        {formErrors.tag_name && <div className="error error-message">{formErrors.tag_name}</div>}
                                    </div>
                                    
                                    
                                    <div className="col-sm-2 boxinput company-search" >
                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                        <a href="#" className={buttonDisabled ? 'disabled-link search-btn clear-btn' : 'search-btn clear-btn'} onClick={handleSave} >Save</a>
                                    </div>
                                </div>
                            </div>}
            
        
                            <div className="fullwidth-table track-table-body staff-listing-admin-table-body">
                                <table>
                                    <thead>
                                    <tr>
                                        <th>Company</th>
                                        <th>Tag Name</th>
                                        <th>Actions</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {tagsList.map((item, index) => (
                                        <tr key={item.id}>
                                            
                                            <td data-label="Company">
                                                {editIndex === index ?
                                                    <>
                                                        <select name="company_id" value={newTags.company_id} onChange={handleInputChange} disabled={role > 2}>
                                                            <option value="">Select Company</option>
                                                            {companyList.map((comp) => (
                                                                <option key={comp.id} value={comp.id}>
                                                                    {comp.cname}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {formErrors.company_id && <div className="error error-message">{formErrors.company_id}</div>}
                                                    </>
                                                    :
                                                    item.cname
                                                }
                                            </td>
                                            <td data-label="Tag Name">
                                                {editIndex === index ? 
                                                    <>
                                                    <input
                                                        type="text"
                                                        name="tag_name"
                                                        placeholder="Tag Name"
                                                        value={newTags.tag_name}
                                                        onChange={handleInputChange}
                                                    />
                                                    {formErrors.tag_name && <div className="error error-message">{formErrors.tag_name}</div>}</> : 
                                                    item.tag_name
                                                }
                                            </td>
                                            
                                            <td data-label="Actions">
                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                            {editIndex === index && <a href="#" className={buttonDisabled ? 'disabled-link' : ''}  onClick={handleSave} ><img src={`${process.env.PUBLIC_URL}/images/success.png`} alt="Save" title="Save Changes" /></a>}
                                                {item.status === 1 && editIndex !== index && <a onClick={() => handleEdit(index)}><img src={`${process.env.PUBLIC_URL}/images/bx-edit.png`} alt="Edit" title="Use this option to edit the tag" /></a>}
                                                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                                <a onClick={() => disableTags(item.id)}><img src={`${process.env.PUBLIC_URL}/images/bx-x-circle.png`} alt="Disable" title="Use this option to disable the tag" /></a>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                                {totalItem > 20 && (<Pagination
                                  activePage={page}
                                  itemsCountPerPage={20}
                                  totalItemsCount={totalItem}
                                  pageRangeDisplayed={5}
                                  onChange={handlePageChange.bind(this)}
                                />)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>               
            </div>
        </div>
    )
}
 
export default TagsSettings